import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Checkbox, Button } from '@mui/material'; 
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { listPurchaseMaintenance , updateBulkPurchase} from '../../modules/purchaseMaintenanceModule/purchaseMaintenance';
import PurchaseMaintenanceList from '../../components/purchaseMaintenanceMng/PurchaseMaintenanceList';

import * as yup from 'yup';
import { useFormik } from 'formik';
import { PurchaseMaintenanceSearchBox } from '../../components/purchaseMaintenanceMng/PurchaseMaintenanceSearchBox';
import InvoiceLinModalConatiner from '../common/form/modal/InvoiceLineModalContainer';
import { listInvoiceApprovalLine } from   '../../modules/empModule/empApproval';
import moment from 'moment';

const PurchaseMaintenanceListContainer = ({ editFunction }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [selectionModel, setSelectionModel] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("revVal2");
  const [searchWords, setSearchWords] = useState(null);
  const [pendingData, setPendingData] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const { PurchaseMaintenanceListCall, loading, error } = useSelector((state) => {
    // 1. 상태 가져오기
    const isLoad = state.loading?.['purchaseMaintenance/LIST_PURCHASE_MAINTENANCE'];
    const rawList = state.purchaseMaintenanceModule.purchaseMaintenance.list || [];
    const err = state.purchaseMaintenanceModule.purchaseMaintenance.error;
    
    // 2. 권한 필터링 + 로딩 처리 로직
    let filtered = [];
    
    // 핵심: 로딩 중이 아닐 때만 리스트를 계산합니다.
    if (!isLoad) {

      filtered = user?.adminRole === 'Y' 
      ? rawList 
      : rawList.filter(item => {
          const isMatch = item.dptUuid === user?.dptUuid;
          return isMatch;
      });
    }
    // 3. 최종 반환
    return {
      PurchaseMaintenanceListCall: filtered, // 로딩 중이면 []이 반환됨
      loading: isLoad,
      error: err 
    };
  });

  const [apprUuid, setApprUuid] = useState(null);
  const { invoiceLines } = useSelector(
    ({ empModule }) => ({
      invoiceLines: empModule.employeeApproval.invoiceLines,
    }),
  );

  useEffect(() => {
    if (invoiceLines) {
      setApprUuid(invoiceLines[0]?.apprUuid);
    } else {
      dispatch(listInvoiceApprovalLine());
    }
  }, [invoiceLines]);

  useEffect(() => {
      searchList(formik?.values);
  }, []);

  const searchList = (values) => {
    let searchData = {
      [values.searchKeyword]: values.searchWords,
      stDt: values.searchStrtDt ? dayjs(values.searchStrtDt).format('YYYY-MM-DD') : '',
      edDt: values.searchEndDt ? dayjs(values.searchEndDt).format('YYYY-MM-DD') : '',
      payYn: values.searchStatus ? values.searchStatus : '',
    };


    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    dispatch(listPurchaseMaintenance(searchData));

  }

  const getFirstDayOfYear = () => {
    const year = new Date().getFullYear();
    return `${year}-01-01`;
  };

  const getAfterWeek = () => {
    const date = new Date();
    date.setDate(date.getDate() + 6);
    return date.toISOString().split('T')[0]; 
  };

  const initialValues = {
    searchKeyword: 'content', 
    searchWords: '',
    searchStrtDt: getFirstDayOfYear(),
    searchEndDt: getAfterWeek(), 
    searchStatus: 'N', 
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
        searchList(values);
        setSubmitting(false);
    },
  });

  const mapRowToData = (row) => {
    return {
      waitUuid: row.id,
      prjUuid: row.prjUuid,
      invTyp: '매입',
      reqCompDt: row.reqCompDt ? moment(row.reqCompDt).format('YYYY-MM-DD') : '',
      partnerUuid: row.partnerUuid,
      partnerNm: row.partnerNm,
      invTxt: row.content,
      invAmt: row.amount,
      invVat: 0,
      prodCompDt: row.payPlanDt ? moment(row.payPlanDt).format('YYYY-MM-DD') : '',
    };
  };

// [단일 요청 버튼]
const handlePublish = useCallback((row) => {
  if(row.payYn === 'Y' || row.payYn === 'S') {
    return;
  }

  if(!apprUuid) {
    alert('결재선 정보가 없습니다. 잠시 후 다시 시도해주세요.');
    return;
  }
  const insertData = {
    type: 'S',
    apprUuid: apprUuid,
    data: [mapRowToData(row)],
    searchParams: {
      [formik.values.searchKeyword]: formik.values.searchWords,
      stDt: formik.values.searchStrtDt,
      edDt: formik.values.searchEndDt,
      payYn: formik.values.searchStatus,
    }
  };
  handleConfirm(insertData);
}, [formik.values, apprUuid, invoiceLines]);

const handleBulkPublish = useCallback(() => {
  if (selectionModel.length === 0) {
    alert('발행할 항목을 선택해주세요.');
    return;
  }

  // 선택된 ID들에 해당하는 전체 데이터 객체 추출
  const selectedRows = PurchaseMaintenanceListCall.filter(row => 
    selectionModel.includes(row.id)
  );

  const hasUnpublishedPrev = selectedRows.some(row => ['N', 'S'].includes(row.prevInvYn));
  if (hasUnpublishedPrev) {
    alert('선택된 항목 중 이전 회차 발행이 완료되지 않은 건이 포함되어 있습니다.');
    return;
  }

  const insertData = {
    type: 'M', // Multiple(일괄) 구분값 (필요 시)
    apprUuid: apprUuid,
    data: selectedRows.map(mapRowToData),
    searchParams: {
      [formik.values.searchKeyword]: formik.values.searchWords,
      stDt: formik.values.searchStrtDt,
      edDt: formik.values.searchEndDt,
    }
  };

  handleConfirm(insertData);
}, [selectionModel, PurchaseMaintenanceListCall, formik.values, apprUuid]);

  const handleConfirm = (pendingData) => {
    if (pendingData) {
      dispatch(updateBulkPurchase(pendingData));
      
      const updatedValues = {
        ...formik.values,
        searchStatus: 'N',
      };

      formik.setValues(updatedValues);

      setPendingData(null);
      setSelectionModel([]);
    }
  };

  const columns = useMemo(
  () => [
    { field: 'id', hide: true },
    { field: 'prjUuid', hide: true },
    { 
      field: 'reqCompDt', 
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          매입 일자
        </div>
      ),
      minWidth: 130, 
      align: 'center', 
      headerAlign: 'center', 
      valueFormatter: (params) => params.value?.substring(0, 10) 
    },
    { field: 'partnerNm', headerName: '매입처', minWidth: 160, align: 'left', headerAlign: 'center' },
    { field: 'partnerUuid', hide: true },
    { field: 'cstNm', headerName: '사업명', minWidth:390, align: 'left', headerAlign: 'center' },
    { field: 'content', headerName: '매입 내용', minWidth: 390, align: 'left', headerAlign: 'center' },
    { field: 'usrNm', headerName: '영업 담당자', minWidth: 100, align: 'center', headerAlign: 'center' },
    { field: 'amount', headerName: '매입 금액', type: 'number', width: 120, align: 'right', headerAlign: 'center', valueFormatter: (params) => params.value?.toLocaleString() },
    { 
      field: 'payPlanDt', 
      renderHeader: () => (
        <div style={{ lineHeight: 'normal', textAlign: 'center' }}>
          지급 예정 일자
        </div>
      ),
      minWidth: 130, 
      align: 'center', 
      headerAlign: 'center', 
      valueFormatter: (params) => params.value?.substring(0, 10) 
    },
    {
      field: 'payYn',
      headerName: '수취 여부',
      width: 110,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const isPublished = params.value === 'Y';
        
        const config = isPublished 
        ? { text: '수취 완료', color: '#2e7d32' } 
        : { text: '수취 확인', color: '#ed6c02' };

        return (
          <Button
            variant="contained"
            size="small"
            style={{
              backgroundColor: config.color,
              color: '#ffffff',
              boxShadow: 'none',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '0.75rem',
              padding: '4px 10px',
              minWidth: '85px',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              handlePublish(params.row);
            }}
          >
            {config.text}
          </Button>
        );
      },
    },
    {
      field: 'check',
      headerName: '선택',
      width: 70,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => {
        const selectableRows = PurchaseMaintenanceListCall?.filter(
          (r) => r.inspectCon !== 'S' && r.invYn !== 'Y' && r.invYn !== 'S'
        ) || [];

        return (
          <Checkbox
            size="small"
            checked={selectableRows.length > 0 && selectionModel.length === selectableRows.length}
            indeterminate={selectionModel.length > 0 && selectionModel.length < selectableRows.length}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectionModel(selectableRows.map((row) => row.id));
              } else {
                setSelectionModel([]);
              }
            }}
          />
        );
      },
      renderCell: (params) => {
        // [잠금 조건] 검수 대기('S') 상태이거나 이미 발행 완료('Y')된 경우 체크박스 잠금
        const isLocked = params.row.payYn === 'Y' || params.row.payYn === 'S';
        
        return (
          <Checkbox
            size="small"
            disabled={isLocked} // 조건에 해당하면 클릭 불가
            checked={selectionModel.includes(params.row.id)}
            onChange={(e) => {
              if (isLocked) return;
              e.stopPropagation();
              const selectedId = params.row.id;
              if (e.target.checked) {
                setSelectionModel((prev) => [...prev, selectedId]);
              } else {
                setSelectionModel((prev) => prev.filter((id) => id !== selectedId));
              }
            }}
          />
        );
      },
    },

  ],
  [PurchaseMaintenanceListCall, selectionModel, setSelectionModel, formik.values.searchStrtDt ], // 이 변수들이 정의되어 있는지 확인하세요.
);


  return (
    <div>
      <PurchaseMaintenanceSearchBox formik={formik} handleAdd={handleBulkPublish} />
      <PurchaseMaintenanceList
        columns={columns}
        loading={loading}
        PurchaseMaintenanceList={PurchaseMaintenanceListCall}
        error={error}
        editFunction={editFunction}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        searchStrtDt={formik.values.searchStrtDt ? dayjs(formik.values.searchStrtDt).format('YYYY-MM-DD') : ''} 
      />
    </div>
  );
};

export default PurchaseMaintenanceListContainer;
